import { HQGetFlexWorkerDetailsResponse } from '../../../../../types';
import { WorkerList } from '../../../../services/flex-worker-service.types';

export const getWorkerLabel = (worker: HQGetFlexWorkerDetailsResponse): WorkerList => {
  return {
    workerId: worker.id,
    email: worker.email,
    firstName: worker.firstName ?? '',
    infix: worker.infix ?? '',
    lastName: worker.lastName ?? '',
    employmentType: worker.employmentType,
  };
};
